import { Box, Stack } from "@chakra-ui/layout";
import { Skeleton, SkeletonCircle } from "@chakra-ui/skeleton";
import { ChatState } from "../Context/ChatProvider";

// Skeleton palette follows the chat theme so placeholders never flash
// the wrong mode.
const palette = (theme) =>
  theme === "light"
    ? { start: "#e2e8f0", end: "#cbd5e1" }
    : { start: "#141b3d", end: "#232c5c" };

// Variants mirror the real rows they stand in for:
// - "list": 64px chat/user rows (avatar + two text lines)
// - "message": thread bubbles (bubble + timestamp line), alternating sides
const ChatLoading = ({ variant = "list", count }) => {
  const ctx = ChatState() || {};
  const c = palette(ctx.theme);

  if (variant === "message") {
    const n = count || 6;
    const widths = ["72%", "56%", "64%", "46%", "68%", "52%"];
    const heights = [56, 40, 64, 36, 52, 44];
    return (
      <Stack spacing={3} w="100%" py={2} aria-label="Loading messages">
        {Array.from({ length: n }).map((_, i) => {
          const mine = i % 2 === 1;
          return (
            <Box
              key={i}
              display="flex"
              justifyContent={mine ? "flex-end" : "flex-start"}
              w="100%"
            >
              <Box w={widths[i % widths.length]} maxW="68%">
                <Skeleton
                  height={`${heights[i % heights.length]}px`}
                  borderRadius="14px"
                  startColor={c.start}
                  endColor={c.end}
                />
                <Skeleton
                  height="10px"
                  mt={1}
                  ml={mine ? "auto" : 0}
                  w="40%"
                  borderRadius="full"
                  startColor={c.start}
                  endColor={c.end}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    );
  }

  const n = count || 8;
  return (
    <Stack spacing={2} aria-label="Loading chats">
      {Array.from({ length: n }).map((_, i) => (
        <Box
          key={i}
          display="flex"
          alignItems="center"
          gap={2}
          minH="64px"
          px={3}
          py={2}
          borderRadius="lg"
        >
          <SkeletonCircle
            size="9"
            startColor={c.start}
            endColor={c.end}
            flexShrink={0}
          />
          <Box flex="1" minW={0}>
            <Skeleton
              height="14px"
              w={`${68 - ((i * 13) % 22)}%`}
              borderRadius="md"
              startColor={c.start}
              endColor={c.end}
            />
            <Skeleton
              height="11px"
              mt={2}
              w={`${88 - ((i * 17) % 30)}%`}
              borderRadius="md"
              startColor={c.start}
              endColor={c.end}
            />
          </Box>
        </Box>
      ))}
    </Stack>
  );
};

export default ChatLoading;
